import { takeLatest, put } from "redux-saga/effects";
import { SET_READY_TO_SUBMIT_RESCUE, setReadyToSubmitRescueSuccess } from "../action/readyToSubmitRescue-action";
import { datadogRum } from "@datadog/browser-rum";



function* setReadyToSubmitRescueSaga(action: ReturnType<typeof setReadyToSubmitRescueSuccess>) {
  try {
    yield put(setReadyToSubmitRescueSuccess(action.payload));
  } catch (error) {
    datadogRum.addError(
          new Error(
            `setReadyToSubmitRescueSaga error setting up the readyToSubmitRescue property`
          )
        );
  }
}

export function* watchReadyToSubmitRescue() {
  yield takeLatest(SET_READY_TO_SUBMIT_RESCUE, setReadyToSubmitRescueSaga);
}